var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCpp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#5C8DBC;}\r\n\t.st1{fill:#1A4674;}\r\n\t.st2{fill:#1B598E;}\r\n\t.st3{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    className: "st0",
    d: "M483.72,150.49c0-8.56-1.82-16.27-5.61-22.72c-3.65-6.45-9.12-11.78-16.41-15.99 C401.12,76.85,340.39,41.93,279.8,7.01c-16.41-9.4-32.12-9.12-48.39,0.42C207.29,21.6,86.4,90.88,50.5,111.78 c-14.87,8.56-22.02,21.74-22.02,38.85c0,70.26,0,140.67,0,210.93c0,8.41,1.82,15.85,5.33,22.3c3.65,6.59,9.26,12.2,16.69,16.55 c36.04,20.9,156.8,90.04,180.92,104.34c16.27,9.54,32.12,9.96,48.39,0.42c60.59-35.06,121.31-69.84,181.9-104.77 c7.57-4.35,13.04-9.82,16.69-16.55c3.51-6.45,5.33-13.88,5.33-22.3C483.72,361.42,483.72,220.75,483.72,150.49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    className: "st1",
    d: "M256.66,255.25L33.53,383.72c3.65,6.59,9.26,12.2,16.69,16.55 c36.04,20.9,156.8,90.04,180.92,104.34c16.27,9.54,32.12,9.96,48.39,0.42c60.59-35.06,121.31-69.84,181.9-104.77 c7.57-4.35,13.04-9.82,16.69-16.55L256.66,255.25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5_",
    className: "st1",
    d: "M190.6,293.26c13.04,22.72,37.45,38.01,65.36,38.01c28.19,0,52.73-15.43,65.64-38.43 l-64.93-37.59L190.6,293.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6_",
    className: "st2",
    d: "M483.72,150.49c0-8.56-1.82-16.27-5.61-22.72L256.66,255.25l221.73,128.47 c3.51-6.45,5.33-13.88,5.33-22.3C483.72,361.42,483.72,220.75,483.72,150.49"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_7_",
    className: "st3",
    points: "471.52,264.51 454.13,264.51 454.13,281.76 436.88,281.76 436.88,264.51  419.49,264.51 419.49,247.12 436.88,247.12 436.88,229.87 454.13,229.87 454.13,247.12 471.52,247.12 471.52,264.51  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_8_",
    className: "st3",
    points: "408.27,264.51 390.88,264.51 390.88,281.76 373.63,281.76 373.63,264.51  356.24,264.51 356.24,247.12 373.63,247.12 373.63,229.87 390.88,229.87 390.88,247.12 408.27,247.12 408.27,264.51  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9_",
    className: "st3",
    d: "M321.6,292.84c-12.9,22.86-37.45,38.43-65.64,38.43c-28.05,0-52.45-15.29-65.36-38.01 c-6.31-11.08-9.96-23.7-9.96-37.31c0-41.65,33.66-75.31,75.31-75.31c27.77,0,52.03,15.15,65.08,37.59l65.78-37.87 c-26.23-45.16-75.03-75.59-130.99-75.59c-83.59,0-151.19,67.74-151.19,151.19c0,27.35,7.29,53.15,20.06,75.31 c26.09,45.3,75.17,75.87,131.27,75.87c56.24,0,105.33-30.71,131.41-76.3L321.6,292.84"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpp);
export default __webpack_public_path__ + "static/media/cpp.85764760e8087daab71afe215fa8d8f8.svg";
export { ForwardRef as ReactComponent };